import moment from "moment";
import React from "react";
import PropTypes from "prop-types";
import get from "lodash-es/get";
import isFunction from "lodash-es/isFunction";
import { useFormikContext } from "formik";
import { DatePicker } from "@mui/x-date-pickers";

export const FormDateField = (props) => {
  const {
    name,
    label,
    withLabel = true,
    helperText,
    entryDateFormat,
    exitDateFormat,
    textFieldClassName,
    textFieldSize,
    id = "date-picker",
    ...otherProps
  } = props;
  const formik = useFormikContext();

  const value = moment.utc(get(formik.values, name, ""), entryDateFormat);
  const touched = get(formik.touched, name, false);
  const error = get(formik.errors, name, "");
  const hasError = Boolean(error);

  const onChange = (value) => {
    let newValue;
    try {
      if (isFunction(exitDateFormat)) {
        newValue = exitDateFormat(value);
      } else {
        newValue = value.format(exitDateFormat);
      }
    } catch (error) {
      newValue = "";
    }
    formik.setFieldValue(name, newValue).then();
  };

  return (
    <DatePicker
      name={name}
      value={value}
      label={withLabel ? label : null}
      onChange={onChange}
      views={["year", "month", "day"]}
      slotProps={{
        textField: {
          className: textFieldClassName,
          fullWidth: true,
          size: textFieldSize,
          error: touched && hasError,
          helperText: (touched && error) || helperText,
        },
        openPickerButton: {
          sx: { marginRight: "-4px" },
          id: `${id}-open-calendar-button`,
        },
        field: {
          id,
        },
      }}
      {...otherProps}
    />
  );
};

FormDateField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  withLabel: PropTypes.bool,
  textFieldClassName: PropTypes.string,
  textFieldSize: PropTypes.string,
  helperText: PropTypes.string,
  entryDateFormat: PropTypes.string,
  exitDateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  format: PropTypes.string,
  id: PropTypes.string,
  views: PropTypes.array,
};
